module.exports = __webpack_public_path__ + "media/images/aloe/icons/categories/kids-4d44ad5acfda25c2469e40b0359b5a0f.svg";